<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3 8C3 8.16576 3.06585 8.32473 3.18306 8.44194C3.30027 8.55915 3.45924 8.625 3.625 8.625H7.27083C7.29846 8.625 7.32496 8.63597 7.34449 8.65551C7.36403 8.67504 7.375 8.70154 7.375 8.72917V12.375C7.375 12.5408 7.44085 12.6997 7.55806 12.8169C7.67527 12.9342 7.83424 13 8 13C8.16576 13 8.32473 12.9342 8.44194 12.8169C8.55915 12.6997 8.625 12.5408 8.625 12.375V8.72917C8.625 8.70154 8.63597 8.67504 8.65551 8.65551C8.67504 8.63597 8.70154 8.625 8.72917 8.625H12.375C12.5408 8.625 12.6997 8.55915 12.8169 8.44194C12.9342 8.32473 13 8.16576 13 8C13 7.83424 12.9342 7.67527 12.8169 7.55806C12.6997 7.44085 12.5408 7.375 12.375 7.375H8.72917C8.70154 7.375 8.67504 7.36403 8.65551 7.34449C8.63597 7.32496 8.625 7.29846 8.625 7.27083V3.625C8.625 3.45924 8.55915 3.30027 8.44194 3.18306C8.32473 3.06585 8.16576 3 8 3C7.83424 3 7.67527 3.06585 7.55806 3.18306C7.44085 3.30027 7.375 3.45924 7.375 3.625V7.27083C7.375 7.29846 7.36403 7.32496 7.34449 7.34449C7.32496 7.36403 7.29846 7.375 7.27083 7.375H3.625C3.45924 7.375 3.30027 7.44085 3.18306 7.55806C3.06585 7.67527 3 7.83424 3 8Z" 
  :class="[props.state]"
  fill="#E7E7F8"/>
  </svg>
</template>

<script setup lang="ts">
export type State = 'active' | 'inactive';

const props = withDefaults(defineProps<{
  state?: State;
}>(), {
  state: 'active'
});


</script>

<style lang="scss" scoped>
.active {
  fill: white;
}

.inactive {
  fill: var(--Primary-160);
}
</style>